import { Badge } from '@lbcamden/lib-react';
import { formatPlural, parseDate } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';
import { FunctionComponent } from 'react';

import { FullPcfraPerson } from '~/common/types/people';

import { getPersonAge } from '../helpers';
import { PcfraStatusTag } from '../PcfraInfo';
import { Divider, HeadingInfoRoot } from './HeadingInfo.styled';

type Props = {
  person: FullPcfraPerson;
  riskFactorCount: number;
};

export const HeadingInfo: FunctionComponent<Props> = ({ person, riskFactorCount }) => (
  <HeadingInfoRoot>
    <span>
      {!!riskFactorCount && (
        <Badge $bgColor="accent" $fontSize={12}>
          {riskFactorCount}
        </Badge>
      )}
      {riskFactorCount ? formatPlural('Risk factor', riskFactorCount) : 'No risk factors'}
    </span>
    <Divider />
    <span>{`${getPersonAge(person.dateOfBirth)} old`}</span>
    <Divider />
    <PcfraStatusTag
      status={person.pcfraStatus}
      noStatusText="No status"
      reviewOverdue={DateTime.now() > parseDate(person.pcfraReviewDate ?? '')}
    />
  </HeadingInfoRoot>
);
